import SharedRecurringTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Recurring'

const RecurringTask = (props: Props) => {
  return <SharedRecurringTask {...props} />
}

export default RecurringTask
